// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconRemove = ({ width, height, color, clickable, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.225 13.224"
      width={width}
      height={height}
      style={{ cursor: clickable ? 'pointer' : 'auto' }}
      {...props}
    >
      <path
        fill={color}
        d="M7.824,6.748,12.973,1.6A.857.857,0,0,0,11.762.387l-5.15,5.15L1.463.387A.857.857,0,0,0,.251,1.6L5.4,6.748.251,11.9a.857.857,0,1,0,1.211,1.211L6.612,7.96l5.15,5.15A.857.857,0,0,0,12.973,11.9Zm0,0"
        transform="translate(0 -0.136)"
      ></path>
    </svg>
  )
}

IconRemove.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  clickable: PropTypes.bool,
}

IconRemove.defaultProps = {
  width: '19px',
  height: '19px',
  color: '#5badfa',
  clickable: false,
}

export default IconRemove
